import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { Colors } from '../../styles/variables';
export const HomeDailyLessonPopoverArrowIcon = ({ color, classObject }) => {
    const arrowColor = color || Colors.White;
    return (React.createElement("svg", { className: css(styles.container, classObject), viewBox: "-10.83 0 68 36", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": true },
        React.createElement("path", { d: "M20.469 1.05191C21.9984 -0.35052 24.3463 -0.350522 25.8757 1.05191L45.0399 18.6248C47.7284 21.0901 45.9842 25.573 42.3365 25.573H4.00821C0.360492 25.573 -1.38369 21.0901 1.30483 18.6248L20.469 1.05191Z", fill: arrowColor })));
};
const styles = StyleSheet.create({
    container: {
        width: 68,
        height: 36,
    },
});
